





































import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import Pagination, {PaginationInput} from '@/modules/core/model/pagination';
import Department from '@/modules/reservation/model/Department';

/**
 * Selector en linea de departamentos del sistema de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class DepartmentInlineSelect extends Vue {
    /**
     * Id del tipo de departamento por el cual filtrar
     */
    @Prop({type: Number, default: -1})
    public type: number

    @Prop({type: Boolean, default: false})
    public disabled: boolean

    @Prop({type: Array, default: () => []})
    public rules: Array<() => boolean | string>

    @State(state => state.reservation.departmentPagination)
    public pagination: Pagination<Department>

    public loading = false
    public select: number[] = []


    public input: PaginationInput = {
        page: 1,
        orderBy: {
            field: 'id',
            direction: 'ASC',
        },
        recordsPerPage: 999,
        filters: {
            type: null,
        },
    }

    public allItems = false

    public selectAll (all: boolean) {
        this.allItems = all
        if (!all) {
            return this.$emit('input', this.select = [])
        }

        this.select = this.pagination.items.map(d => d.id)
        this.$emit('input', this.pagination.items)
    }

    @Watch('type', {immediate: true})
    public onTypeChange (type: number) {
        this.input.filters!.type = type
    }

    @Watch('input', {immediate: true, deep: true})
    public async loadPagination () {
        if (this.disabled) {
            return
        }

        this.loading = true
        await this.$store.dispatch('reservation/loadDepartmentPagination', this.input)

        this.select = []
        this.allItems = false
        this.loading = false
    }
}
